<div class="d-flex flex-column" style="min-height: 37rem">
  <div
    class="pb-5"
    style="
      flex-grow: 1;
      background-color: #001c33 !important;
      color: white;
      font: Space Grotesk;
    "
  >
    <section class="about-us text-lg-center text-start px-2 text-white">
      <div class="container">
        <h2 class="display-4 mb-4">
          {{ "aboutUs.title-1" | translate }}
          <span class="fw-bold">{{ "aboutUs.title-2" | translate }}</span>
          {{ "aboutUs.title-3" | translate }}
          <span class="fw-bold">{{ "aboutUs.title-4" | translate }}</span>
        </h2>

        <p class="lead mb-5 opacity-75">
          {{ "aboutUs.details" | translate }}
        </p>

        <button class="custom-button mx-lg-auto" routerLink="/contact">
          <span class="button-content">
            {{ "aboutUs.collaborateWithUs" | translate }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="bi arrow-1"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
          </span>

          <div class="icon-circle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="bi arrow-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              />
            </svg>
          </div>
        </button>
      </div>
    </section>

    <!-- Who We Are -->
    <section class="who-we-are text-white">
      <div class="container">
        <div class="row justify-content-between gap-3 px-2 px-lg-0">
          <div class="col-12 col-md-4 col-lg-3">
            <h2 class="fw-normal border-bottom pb-1 d-inline-block">
              {{ "whoWeAre.title" | translate }}
            </h2>
          </div>
          <div class="col-12 col-md-7 col-lg-8">
            <p style="font-size: 18px">
              {{ "whoWeAre.details" | translate }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- What We Do -->
    <div class="container">
      <div class="section-title text-lg-center text-start py-4">
        <p>{{ "aboutUs.whatwedo" | translate }}</p>
        <h4>{{ "whatwedo.title1" | translate }}</h4>
        <h4>
          <span>{{ "whatwedo.title2" | translate }} </span>
        </h4>
        <img src="/public/icons/Elements-geometric-line-nature-wave.svg" />
      </div>
    </div>
    <div class="container services-icons py-4">
      <div class="row text-center fw-semibold px-3">
        <div class="what-we-do col-xl-3 col-md-6 col-12">
          <img src="/public/icons/Simplification.svg" alt="code" />
          <p>{{ "whatwedo.paragh1" | translate }}</p>
        </div>
        <div class="what-we-do col-xl-3 col-md-6 col-12">
          <img src="/public/icons/Integartion.svg" alt="integration" />
          <p>{{ "whatwedo.paragh2" | translate }}</p>
        </div>
        <div class="what-we-do col-xl-3 col-md-6 col-12">
          <img src="/public/icons/IT CONSULT.svg" alt="consulting" />
          <p>{{ "whatwedo.paragh3" | translate }}</p>
        </div>
        <div class="what-we-do col-xl-3 col-md-6 col-12">
          <img src="/public/icons/b2b.svg" alt="b2b" />
          <p>{{ "whatwedo.paragh4" | translate }}</p>
        </div>
      </div>
    </div>

    <!-- Quote Box -->
    <div class="container">
      <div class="quote-box position-relative w-lg-75 w-100">
        <div class="quote-icon1 position-absolute">
          <img
            src="/public/icons/Sketch-annotation-element-stroke-abstract--highlight-bling-line-2.svg"
            alt="quote"
          />
        </div>
        <p>
          {{ "quote.text" | translate }}
        </p>
        <div class="quote-icon2 position-absolute">
          <img
            src="/public/icons/Sketch-annotation-element-stroke-abstract--highlight-bling-line-2 (1).svg"
            alt="quote"
          />
        </div>
      </div>
    </div>
    <!-- Mission -->
    <div class="container position-relative">
      <div class="mission-section">
        <div class="mission-circle text-center">
          {{ "ourmission.title" | translate }} <br />
          {{ "ourmission.title2" | translate }}
        </div>
        <div class="mission-text w-75">
          {{ "ourmission.details" | translate }}
        </div>
      </div>
      <img
        src="/public/icons/Elements-geometric-shape-star-password.svg"
        class="star d-none d-md-block"
      />
    </div>
  </div>
</div>
